import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';

// Import styles
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '../../assets/css/pdfViewerStyles.css';

const ReactPdfViewer = (props) => {

  const toolbarPluginInstance = toolbarPlugin();
  const {Toolbar} = toolbarPluginInstance;

  /*const renderToolbar = (Toolbar, ToolbarProps) => React.createElement(Toolbar, ToolbarProps, (slots) => {
    const { CurrentPageLabel, GoToNextPage, GoToPreviousPage, NumberOfPages, ZoomIn, ZoomOut, Zoom } = slots
    return (
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <div style={{ padding: '0px 2px' }}>
          <ZoomOut/>
        </div>
        <div style={{ padding: '0px 2px' }}>
          <Zoom/>
        </div>
        <div style={{ padding: '0px 2px' }}>
          <ZoomIn/>
        </div>
        <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
          <GoToPreviousPage/>
        </div>
        <div style={{ padding: '0px 2px' }}>
          <CurrentPageLabel /> / <NumberOfPages />
        </div>
        <div style={{ padding: '0px 2px' }}>
          <GoToNextPage/>
        </div>
      </div>
    )
  })*/

  /*renderToolbar = (toolbarSlot) => {
    return (
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          width: '100%',
        }}
      >
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            flexGrow: 1,
            flexShrink: 1,
            justifyContent: 'center',
          }}
        >
          <div style={{ padding: '0 2px' }}>
            {toolbarSlot.previousPageButton}
          </div>
          <div style={{ padding: '0 2px' }}>
            {toolbarSlot.currentPage + 1} / {toolbarSlot.numPages}
          </div>
          <div style={{ padding: '0 2px' }}>
            {toolbarSlot.nextPageButton}
          </div>
          <div style={{ padding: '0 2px' }}>
            {toolbarSlot.zoomOutButton}
          </div>
          <div style={{ padding: '0 2px' }}>
            {toolbarSlot.zoomPopover}
          </div>
          <div style={{ padding: '0 2px' }}>
            {toolbarSlot.zoomInButton}
          </div>
        </div>
      </div>
    );
  };*/

  /*const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
    sidebarTabs: defaultTabs => [
      {
        content: (
          <div></div>
        ),
        icon: (
          <Icon></Icon>
        ),
        title: (<>Notes</>),
      }
    ]
  })*/

  return (
    <React.Fragment >
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
        <div style={{ height: props.height }}>
          <Toolbar>
            {
              (props) => {
                const { CurrentPageLabel, GoToNextPage, GoToPreviousPage, NumberOfPages, ZoomIn, ZoomOut, Zoom } = props;
                return (
                  <div
                    style={{
                      alignItems: 'center',
                      display: 'flex',
                      flexGrow: 1,
                      flexShrink: 1,
                      justifyContent: 'center',
                    }}
                  >
                    <div style={{ padding: '0px 2px' }}>
                      <ZoomOut/>
                    </div>
                    <div style={{ padding: '0px 2px' }}>
                      <Zoom/>
                    </div>
                    <div style={{ padding: '0px 2px' }}>
                      <ZoomIn/>
                    </div>
                    <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                      <GoToPreviousPage/>
                    </div>
                    <div style={{ padding: '0px 2px' }}>
                      <CurrentPageLabel /> / <NumberOfPages />
                    </div>
                    <div style={{ padding: '0px 2px' }}>
                      <GoToNextPage/>
                    </div>
                  </div>
                )
              }
            }
          </Toolbar>
          <Viewer fileUrl={props.pdf} plugins={[
            toolbarPluginInstance
          ]} />
        </div>
      </Worker>
    </React.Fragment>
  )

}

export default ReactPdfViewer
